import Model, { attr, belongsTo } from '@ember-data/model';
import type DigitalAssetModel from './digital-asset.ts';
import { Type } from '@warp-drive/core-types/symbols';

export default class AttachmentModel extends Model {
  @attr declare signedUrl: string;
  @attr declare classification: string;
  @attr declare createdAt: string;
  @attr declare description: string;
  @attr declare tags: string[];
  @attr declare attachmentDeletedAt: string | null;

  @attr declare filename: string;
  @attr declare contentType: string;
  @attr declare name: string;

  @attr declare assetClassification: string;
  @attr declare assetDescription: string;

  get displayClassification(): string {
    return this.classification || this.assetClassification;
  }

  get displayDescription(): string {
    return this.description || this.assetDescription;
  }

  @belongsTo('digital-asset', { async: false, inverse: null })
  declare digitalAsset: DigitalAssetModel;

  [Type] = 'attachment' as const;
}
